export const API_BASE_URL = "api/v2";
export const ENDPOINTS_BASE_URL = "_ah/api";

export const BASE_SERVICE_URL = {
  customer: "/customer",
  storage: "/storage",
  documents: "/documents",
  historical: "/historical",
} as const;

export const CUSTOMER_SERVICES = {
  office: "/office",
  lawsuit: "/lawsuit",
  case: "/case",
  info: "/info",
  caseDocuments: "/lawsuit/documents",
  documents: "/documents",
  movements: "/movements",
} as const;

export const STORAGE_SERVICES = {
  downloadFile: "/download-file",
};

export const LAWSUIT_ENDPOINTS = {
  count: "/count",
};

export const DOCUMENTS_ENDPOINTS = {
  filled: "/filled",
};
